import { useTranslation } from 'react-i18next';
import { getTimezone } from '@urc-ui/services/app-context';

/**
 * This function uses the i18n formatting API to format and localize dates. Given input dates, this function returns a
 * localized string representation for each date.
 * See https://www.i18next.com/translation-function/formatting
 * @param {Object[]} dates - list of objects for localized formatting
 * @param {Date} dates[].value - Javascript Date object(js date, timestamp, etc)
 * @param {Object} dates[].format - Optional formatting options using Intl.DateTimeFormat. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 * @return localized list of dates
 */
type LocalizedDateObject = {
  value: Date | number | undefined | null;
  format?: Intl.DateTimeFormatOptions;
};
const useLocalizedDate = (dates: LocalizedDateObject[]) => {
  const { i18n } = useTranslation();
  return dates.map(d => {
    const format = d?.format || {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: getTimezone()
    };
    return i18n.format(d.value, 'datetime', i18n.language, format);
  });
};

export { useLocalizedDate };
